import { TypeChecker } from '@attain-apps/type-guards'

export interface Config {
  /**
   * Indicated whether the select is slim or not.
   *
   * @default false
   */
  isSlim?: boolean
  /** TODO: add documentation */
  expandedElMaxHeight?: number
  /** TODO: document */
  overlay?: Config.Overlay
}
export namespace Config {
  export const isConfig = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.object({
      expandedElMaxHeight: TypeChecker.Factory.optional(TypeChecker.isNumber),
      overlay: TypeChecker.Factory.optional(Overlay.isOverlay),
    }),
  )

  export interface Overlay {
    /**
     * Explicit overlay width in pixels.
     *
     * Set to `'fit-content'` to size the single-select overlay to the widest
     * available item label plus the existing horizontal padding while keeping
     * the overlay at least as wide as its trigger.
     *
     * Multi-select currently supports numeric widths only. Non-numeric values
     * fall back to the trigger width there.
     *
     * @default trigger width
     */
    width?: Overlay.Width
    /**
     * @default 260px
     */
    maxHeight?: number
    /**
     * TODO:
     *
     * @default undefined
     */
    minSearchCharacters?: number
    /**
     * @default ''
     */
    entityName?: string
    /**
     * @default false
     */
    hasSearch?: boolean
  }

  export namespace Overlay {
    const WIDTHS = ['fit-content'] as const

    export type Width = number | (typeof WIDTHS)[number]

    export namespace Width {
      export const isWidth = TypeChecker.Factory.union(
        TypeChecker.isNumber,
        TypeChecker.Factory.oneOf(WIDTHS),
      )
    }

    export const isOverlay = TypeChecker.Factory.object({
      entityName: TypeChecker.Factory.optional(TypeChecker.isString),
      hasSearch: TypeChecker.Factory.optional(TypeChecker.isBoolean),
      maxHeight: TypeChecker.Factory.optional(TypeChecker.isNumber),
      minSearchCharacters: TypeChecker.Factory.optional(TypeChecker.isNumber),
      width: TypeChecker.Factory.optional(Width.isWidth),
    })
  }
}
